import React from "react";
import QuesCard from "../components/QuesCard";
import "../components/question.css";
const ScreenQuestion = () => {
  return (
    <div className="bg-gray-200  h-[100vh] flex justify-center items-center">
      <QuesCard />
    </div>
  );
};

export default ScreenQuestion;
